import React from "react";
import '../../assets/css/style.css';
import CardItemsDan from './cards-item';
import AddCardImg from '../../assets/img/addcard2.svg';
import VarizReqImg from '../../assets/img/varizreq.svg';
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

const CardsDan = () => {

  const navigate = useNavigate();


  const [userCards, setUserCards] = useState([]);

  const [mojodiuser, setmojodiuser] = useState(null);
  



  useEffect(() => {
    const userInfo = localStorage.getItem("userinfo");
    if (userInfo) {
      const parsedInfo = JSON.parse(userInfo);
      setmojodiuser(parsedInfo.mojodi_tmn || 0);
    }

    // دریافت اطلاعات کارت‌های بانکی از API
    const fetchUserCards = async () => {
      const token = localStorage.getItem("donetoken");
      if (!token) return;
      
      try {
        const response = await fetch(`https://app.doneapp.ir/backend/get_user_cards.php?token=${token}`);
        const data = await response.json();
        if (data.status === "success") {
          setUserCards(data.cards);
        }
      } catch (error) {
        console.error("Error fetching user cards:", error);
      }
    };

    fetchUserCards();
  }, []);




  const handelwithdraw = () => {
alert("درخواست شما ثبت شد.");
  };






  return (
    <>
   <div className="mohtava-mine" >
     
 <section id="cards" className="dir-r max-cntt-w" >
   
                        <div className="cards-div-1" ></div>
        
                   
                        <CardItemsDan cards={userCards} />
                                   
                               
              




 <div className="cards-div-3" >
                            
 <div className="cards-div-4 " >
موجودی شما:
{mojodiuser}
تومان
</div>


<div className="cards-div-5" >
      
       <button className="cards-btn-2" onClick={() => navigate("/panel/transactions")}  >
        سوابق تراکنش
        </button>
    
   
        <button className="cards-btn-3"  onClick={() => navigate("/panel/add-bank")} >

         <img src={AddCardImg} className="ml-5" alt="add"  /> 
        افزودن حساب بانکی
  
       
    </button>
        
        </div>
        
        <div className="cards-div-6" >
            <button
            onClick={handelwithdraw}
            className="cards-btn-4"  >
    
         <img src={VarizReqImg} className="ml-5" alt="variz" />
         درخواست واریز وجه</button>
        </div>

        </div>
 
       <div className="h-100">
           
       </div>
   
       </section>
 
   </div>
    </>
       
   );
};

export default CardsDan;
